export { default } from './ExternalLinksCollection';
export { default as ExternalLinksShape } from './ExternalLinksShape';



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/index.js